import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { SheetSlotComponentBase } from 'src/app/services/sheets-renderer.service';
import { RespiratoryRateActionV2 } from 'src/app/types/sheet-action-aggregate-graph.types';
import { TickValueComponent } from '../../tick-value/tick-value.component';

@Component({
    selector: 'app-respiratory-rate-and-effort-slot-v2',
    templateUrl: './respiratory-rate-and-effort-slot-v2.component.html',
    styleUrl: './respiratory-rate-and-effort-slot-v2.component.scss',
    imports: [TickValueComponent],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class RespiratoryRateSlotComponentV2 implements SheetSlotComponentBase {

	action!: RespiratoryRateActionV2;
	value!: string | null;

	@Input('action') set updateAction(action: RespiratoryRateActionV2 | null) {
		this.action = action as RespiratoryRateActionV2;
		this.value = this.action.breathsPerMinute?.quantity?.toString() ?? null;
	}

	constructor() {
	}
}